import React, { useRef, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Mensaje } from '../components/mensajes';

import useTable from '../components/useTable';
import { TableBody, TableRow, TableCell } from '@mui/material'
;
import { Dimmer } from '../components/spinner';
import { formatMoneda } from '../util/varios'; 
import axios from "axios";


const CatalogoAllCuentasContables = props => {

    let op = require('../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');
    const idefiscal = JSON.parse(localStorage.getItem('idefiscal'))


    const btnAcepta = useRef();
    const btnCancela = useRef();
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [activate, setActivate] = useState(false);
    const [records, setRecords] = useState([]);
    const [values, setValues] = useState({
       idplancuenta:''});
    const [itemSelect, setItemSelect] = useState(-1);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })

    const headCells = [
        { label: 'CODIGO', textAlign: 'center', backgroundColor: "rgb(5, 81, 130)", color: 'white' },
        { label: 'DESCRIPCION', textAlign: 'center', backgroundColor: "rgb(5, 81, 130)", color: 'white' },
        { label: 'id', textAlign: 'center', backgroundColor: "rgb(5, 81, 130)", color: 'white' },

        
    ]

    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTable(records, headCells, filterFn);

    const handleSearch = e => {
        let target = e.target;

        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items;
                } else {
                    return items.filter(x => {
                        if ((x.codigocuenta.substring(0,2) + '-' + x.codigocuenta.substring(2,5) + '-' + x.codigocuenta.substring(5,7) + '-' + x.codigocuenta.substring(7,9) + '-' + x.codigocuenta.substring(9,12)).toLowerCase().includes(target.value.toLowerCase())
                            //|| x.codigocuenta.toLowerCase().includes(target.value.toLowerCase())
                            || x.descripcion.toLowerCase().includes(target.value.toLowerCase())
                            || x.idplancuenta.includes(target.value)) {
                            return x;
                        }
                    });
                }
            }
        })

    }

    const seleccionarRegistros = () => {

        let campos = '*';
       
        let nomtab = 'plancuenta';
        let nomid = 'idefiscal';
        let nomid2 = 'cargable';
        let id2 = 'true';
    
    
        let endpoint = `${op.conexion}/api/consulta/modeli2?campos=${campos}&id=${idefiscal}&nomtab=${nomtab}&nomid=${nomid}&nomid2=${nomid2}&id2=${id2}`;

        setActivate(true);

        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then(function (response) {

            if (response.status === 200) {
                if (response.data.length > 0) {
                    setRecords(response.data);
                }         
            }


        }).catch(function (error) {

            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
            setActivate(false);

        }).finally(()=>{
            setActivate(false); 
        })

    }


    const blanquear = () => {
        setItemSelect("");
        setActivate(false);
        setRecords([]);
        setValues({
            idmoneda: '',
            descripcion: '',
            simbolo: '',
            predeterminada: false,
            valormoneda: ''
        });
        setFilterFn({ fn: items => { return items; } });
    }


    const cancelar = () => {

        blanquear();
        props.onHideCancelar();
    }


    const seleccionarMoneda = () => {
  
        props.onHideAceptaCatalogo(values);

    };

    const seleccionarFila = (item) => (e) => {
        e.preventDefault();
        setValues({
            idplancuenta: item.idplancuenta,
           
        });
        btnAcepta.current.focus();
    };

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            backdrop="static"
            keyboard={false}
            onShow={() => {
                blanquear();
                seleccionarRegistros();
            }}
        >
            <Modal.Header className='azulGradiant'>
                <div className="fw-bold text-light"><h3>Seleccionar Cuenta Contable</h3></div>
                <button ref={btnCancela} className="bg-transparent" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="far fa-window-close"></i>
                </button>
            </Modal.Header>
            <Modal.Body>
                <Mensaje mensaje={mensaje}
                    onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />
              <Dimmer active={activate} inverted>
       
      </Dimmer>
                <div className="col-md-12 m-0">

<div className="input-group input-group-sm mb-3 m-0 col-md-5">
    <input type='text'
        onChange={handleSearch} className="form-control rounded-pill search-input" />
</div>
</div>
                <div className="col-md-12" style={{ margin: "auto" }} >
                    <TblContainer >
                        <TblHead />

                        <tbody>
                            {
                                records && recordsAfterPagingAndSorting().map((item, index) => (
                                    <tr key={index} style={{ padding: "0", cursor: 'pointer', background: values.idplancuenta === item.idplancuenta ? "lightskyblue" : "white" }} onClick={seleccionarFila(item)}>
                                        <td className='py-2 text-center'>{item.codigocuenta.substring(0,2) + '-' + item.codigocuenta.substring(2,5) + '-' + item.codigocuenta.substring(5,7) + '-' + item.codigocuenta.substring(7,9) + '-' + item.codigocuenta.substring(9,12)}</td>
                                        <td className='py-2 text-start'>{item.descripcion}</td>
                                        <td className='py-2 text-start'>{item.idplancuenta}</td>
                                      
                                    </tr>

                                ))
                            }
                        </tbody>

                    </TblContainer>
                    <TblPagination />

                </div>
            </Modal.Body>
            <Modal.Footer>
                <button ref={btnAcepta} className="btn btn-sm btn-success rounded-pill" style={{ margin: "5px" }} onClick={seleccionarMoneda}><i className="fas fa-check-circle"> Aceptar</i> </button>
                <button ref={btnCancela} onClick={cancelar} className="btn btn-sm btn-danger rounded-pill"><i className="fas fa-window-close"> Cancelar</i></button>
            </Modal.Footer>
        </Modal>
    );
}

export default CatalogoAllCuentasContables;